import { api_configuration } from "../../../common";
import { translate } from "../../front/translate";
import * as reQuery from "../../state 2 interface/reQuery";
import * as ClientState from "../../state/ClientState";
import { importCsv, ImportError } from "../../state/csv-importer";
import api_cs = api_configuration.types.client_state.alan_api;
import messages = require("../../front/messages");

const CSV_IMPORT_FAILED_KEY = "csv-import-failed";
const CSV_IMPORT_SUCCESS_KEY = "csv-import-success";
export async function forQuery(query: api_cs.Cquery__use_for__query, file: File): Promise<void> {
	const context_node = query.inferences.node();
	const gui_node = query.inferences.node_context().properties.path.output.result_node().output.gui_entity();
	switch (context_node.properties.modified.state.name) {
		case "no":
			break;
		case "yes":
			if (
				//FIXME move this to the controls
				!confirm(translate("There are unsaved changes which might be overwritten. Are you sure you want to continue?"))
			) {
				return;
			}
			break;
		default:
			unexpectedState(context_node.properties.modified.state);
	}
	// Set status to importing
	query.parent.properties.entries_are_editable.switch({
		no: undefined,
		yes: ($) => {
			$.properties.is_importing.set("yes", {});
		},
	});

	messages.removeMessage(CSV_IMPORT_FAILED_KEY);
	messages.removeMessage(CSV_IMPORT_SUCCESS_KEY);
	const transaction = ClientState.transact();
	try {
		await importCsv(context_node, gui_node, file);
		messages.addMessage("success", "Sucessfully imported CSV file", {
			key: CSV_IMPORT_SUCCESS_KEY,
			body: "Changes have been saved",
		});
		reQuery.execute(query.parent);
	} catch (error) {
		if (error instanceof ImportError) {
			messages.addMessage("error", "Failed to import file", {
				body: error.message,
				key: CSV_IMPORT_FAILED_KEY,
			});
			//FIXME set state and let the user decide
			reQuery.execute(query.parent);
		} else {
			throw error;
		}
	} finally {
		transaction.unsubscribe();
		query.parent.properties.entries_are_editable.switch({
			no: undefined,
			yes: ($) => {
				$.properties.is_importing.set("no", {});
			},
		});
	}
}
